import Cookies from './Cookies';
import TimeType from './TimeType';

/**
 * custom/wrapper API for storing key/value pair data in cookie, sessionStorage or localStorage
 * example usage:
 * var obj=new ApexChat.WebStorage({type:'cookie'|'session'|'local'});
 * var obj=new ApexChat.WebStorage();//use cookie by default AND if cookie disabled fallback on localStorage
 */
const WebStorage = (options) => {
    const COOKIE_STORAGE = Cookies;
    let WEB_STORAGE;
    const IS_COOKIE_ENABLED = (function () {
        let { cookieEnabled } = navigator;
        if (!cookieEnabled) {
            document.cookie = 'testcookie';
            cookieEnabled = document.cookie.indexOf('testcookie') != -1;
        }
        return cookieEnabled;
    })();
    const IS_STORAGE_SUPPORTED = (function () {
        const uid = new Date();
        let result;
        try {
            if (options && options.type == 'session') WEB_STORAGE = window.sessionStorage;
            else if (options && options.type == 'local') WEB_STORAGE = window.localStorage;
            else WEB_STORAGE = window.localStorage; // default fall back storage IF cookie is disabled
            WEB_STORAGE.setItem(uid, uid);
            result = WEB_STORAGE.getItem(uid) == uid;
            WEB_STORAGE.removeItem(uid);
            return true; // result && WEB_STORAGE;
        } catch (e) {
            return false;
        }
    })();
    // console.log(options.type);
    const UseCookie = (options && options.type == 'cookie') || (!options && IS_COOKIE_ENABLED);
    // console.log(IS_COOKIE_ENABLED);
    // console.log(UseCookie);
    const UseWebStorage = !UseCookie && IS_STORAGE_SUPPORTED;
    // console.log(UseWebStorage);
    // By now we should have SET what storage to use based on User Preference AND Browser Support
    if (!UseCookie && !UseWebStorage) {
        console.log(
            'Exceptional Case: No Cookie, No Web Storage Supported/Enabled on Browser!!!!'
        );
    }
    const existsKey = function (key) {
        if (UseCookie) return COOKIE_STORAGE.get(key) != null;
        if (UseWebStorage) return WEB_STORAGE.getItem(key) !== null;
        return false;
    };
    const get = function (key) {
        if (UseCookie) return COOKIE_STORAGE.get(key);
        if (UseWebStorage) return WEB_STORAGE.getItem(key);
        return null;
    };
    const set = function (key, item) {
        if (UseCookie) {
            const args = arguments.length;
            if (args == 2) {
                COOKIE_STORAGE.set(key, item);
            } else if (args == 3) {
                COOKIE_STORAGE.set(key, item, arguments[2]);
            }
        } else if (UseWebStorage) WEB_STORAGE.setItem(key, item);
    };
    const setTemp = function (key, item) {
        // store for only 2Hours or 120min
        // if (UseCookie) { COOKIE_STORAGE.set(key, item, (1 / 144) * 12); } // 1/144 = 10min & (1/144)*12 = 2Hours
        // store for only 30min..
        if (UseCookie) {
            COOKIE_STORAGE.set(key, item, (1 / 144) * 3);
        } // 1/144 = 10min
        else if (UseWebStorage) {
            WEB_STORAGE.setItem(key, item);
        }
    };
    const getFormulaByTimeType = function (type, value) {
        let formula = value;
        switch (type) {
            case TimeType.Second:
                formula = value * 1000;
                break;
            case TimeType.Minute:
                formula = value * 60 * 1000;
                break;
        }
        return formula;
    };
    // It sets cookie for limited time it takes 3rd argument 'config' which should contain timeType & expirationDuration
    const setLimitedTimeCookie = function (name, value, config) {
        let expires;
        if (name) {
            if (config.timeType) {
                const date = new Date();
                const duration = getFormulaByTimeType(config.timeType, config.expiringDuration);
                date.setTime(date.getTime() + duration);
                expires = `; expires=${date.toGMTString()}`;
            } else {
                expires = '';
            }
            document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`;
        }
    };
    const remove = function (key) {
        if (UseCookie) COOKIE_STORAGE.del(key);
        else if (UseWebStorage) WEB_STORAGE.removeItem(key);
        // confirm
        return !existsKey(key);
    };
    const remember = function (key) {
        set(key, true);
    };
    const getAllKeys = function () {
        if (UseCookie) return COOKIE_STORAGE.list();
        if (UseWebStorage) {
            const arr = [];
            for (const key in WEB_STORAGE) {
                arr.push(key);
            }
            return arr;
        }
        return null;
    };
    return {
        Remove: remove,
        Get: get,
        Store: set,
        StoreUntil: setLimitedTimeCookie,
        StoreTemp: setTemp,
        Exists: existsKey,
        Keys: getAllKeys,
        Remember: remember
    };
};
export default WebStorage;
